export default "__VITE_ASSET__lm478U4j__"